import React, { useEffect, useState } from "react";
import { GoogleReCaptcha } from "react-google-recaptcha-v3";
import { authActions } from "../../../context/actions/authActions";
import useStore from "../../../context/useStore";
import ForgotPassword from "./ForgotPasswordForm/ForgotPassword";
import LoginForm from "./LoginForm/LoginForm";

var timerInterval = null;
var recaptcha;

const Login = () => {
  const [state, dispatch] = useStore();
  var actions = authActions(state, dispatch);
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [forgotPassword, setForgotPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [timer, setTimer] = useState(0);
  const [captchaToken, setCaptchaToken] = useState(false);
  const [register, setRegister] = useState(false);

  const [canLoggin, setCanLoggin] = useState(true);

  useEffect(() => {
    document.querySelector(".login-form").scrollIntoView();
  }, []);

  useEffect(() => {
    if (Object.values(state.errors).length > 0) {
      updateToken();
      setIsLoading(false);
      if (state.errors.password) {
        setPassword("");
      }
      if (state.errors.timer) {
        clearInterval(timerInterval);
        setTimer(parseInt(state.errors.timer));
      }
    }
  }, [state.errors]);

  useEffect(() => {
    setTimer(false);
    setCanLoggin(true);
    setCaptchaToken(false);
    updateToken();
  }, [forgotPassword]);

  function loginHandle(e) {
    e.preventDefault();

    actions.loginUser({ login, password, captchaToken });
    //actions.loginUser({ login, password });
  }

  useEffect(() => {
    if (timer > 0) {
      setCanLoggin(false);
    }
  }, [timer]);

  function timerFinish() {
    setCanLoggin(true);
  }

  const verifyCallback = (recaptchaToken) => {
    // Here you will get the final recaptchaToken!!!

    setCaptchaToken(recaptchaToken);
  };

  const updateToken = () => {
    // you will get a new token in verifyCallback
    if (recaptcha) {
      recaptcha.execute();
    }
  };

  return (
    <div
      className="container-fluid h-100 d-center w-100 flex-column"
      style={{ minHeight: "100vh" }}
    >
      <div className="row w-100">
        <div
          className="col-12 p-4 mx-auto bg-white"
          style={{
            maxWidth: 400,
          }}
        >
          <div className="custom-card overflow-hidden pt-0">
            {forgotPassword ? (
              <ForgotPassword
                setForgotPassword={setForgotPassword}
                captchaToken={captchaToken}
              />
            ) : (
              <>
                <LoginForm
                  login={login}
                  setLogin={setLogin}
                  password={password}
                  setPassword={setPassword}
                  loginHandle={loginHandle}
                  canLoggin={canLoggin}
                  timer={timer}
                  timerFinish={timerFinish}
                  isLoading={isLoading}
                />
                <div className="w-75 mx-auto d-flex justify-content-center mt-3 mt-2">
                  <button
                    type="button"
                    style={{ fontSize: 12 }}
                    onClick={() => setForgotPassword(true)}
                    className="btn btn-link p-0"
                  >
                    mot de passe oublié ?
                  </button>
                </div>
              </>
            )}
          </div>
        </div>

        {!captchaToken && <GoogleReCaptcha onVerify={verifyCallback} />}
      </div>
      <div
        className="mt-4 text-center px-3"
        style={{
          fontSize: 9,
          right: 0,
        }}
      >
        This site is protected by reCAPTCHA and the Google{" "}
        <a href="https://policies.google.com/privacy">Privacy Policy</a> and{" "}
        <a href="https://policies.google.com/terms">Terms of Service</a> apply.
      </div>
    </div>
  );
};

export default Login;
